/* G9 truth-data-ops (Pergolux P0, 5 Oct 2026). TH-02: Klaviyo form events to Clarity.
   Listens to Klaviyo's klaviyoForms window event (open, embedOpen, close, submit, stepSubmit, redirectedToUrl)
   for the ten WL5 forms in window.WL_G9.forms (snippets/wl-g9-assets.liquid) and sends kl_open, kl_close,
   kl_submit, kl_step or kl_link through G1's window.wlTrack, looked up when each event fires.
   placement: exit_worry or signup. value: the page template, or family_play on Family Play pages.
   Only these fixed keys are sent: no form field, email or typed text is read. Without wlTrack nothing is sent
   (no direct clarity or gtag call). SB-P1P2 adds TH-05 (popup gate) and TH-10 (blocker answers). */
(function () {
  if (window.__wlG9) return;
  window.__wlG9 = true;
  var cfg = window.WL_G9 || {};
  var forms = cfg.forms || {};
  var has = Object.prototype.hasOwnProperty;
  var TYPE = { open: 'kl_open', embedOpen: 'kl_open', close: 'kl_close', submit: 'kl_submit', stepSubmit: 'kl_step', redirectedToUrl: 'kl_link' };
  // G1 keeps a value only if it matches ^[a-z0-9_]{1,24}$, so template names such as list-collections are normalised here.
  var clean = function (v) {
    if (v == null) return null;
    v = String(v).toLowerCase().replace(/[^a-z0-9_]/g, '_').slice(0, 24);
    return /^[a-z0-9_]{1,24}$/.test(v) ? v : null;
  };
  var value = cfg.fp ? 'family_play' : clean(cfg.pageType);
  var track = function (name, placement) {
    try {
      if (typeof window.wlTrack !== 'function') return;
      var props = { placement: placement };
      if (value) props.value = value;
      window.wlTrack(name, props);
    } catch (e) {}
  };
  window.addEventListener('klaviyoForms', function (e) {
    try {
      var d = e && e.detail;
      if (!d || d.formId == null || typeof d.type !== 'string') return;
      var id = String(d.formId);
      if (!has.call(forms, id) || !has.call(TYPE, d.type)) return;
      track(TYPE[d.type], forms[id]);
    } catch (err) {}
  });
})();
